module.exports = __webpack_public_path__ + "img/home-hero-image_small.0b2eeec3.jpg";